import { Component, Input } from '@angular/core';

@Component({
  selector: 'ubs-overview-contacts',
  templateUrl: './overview-contacts.component.html',
  styleUrls: ['./overview-contacts.component.scss']
})
export class OverviewContactsComponent {
  @Input() facilityId:string;
}
